import ApiUtils from '@/utils/api/ApiUtils'
import C2001Const from './C2001Const'

const StoreConst = C2001Const.storeConst
const store = {
  getters: {
    getRow (state, getters, rootState, rootGetters) {
      const C0101row = rootGetters['C0101Project/getRow']

      return {
        ...state.row,
        project_funding_target: {
          coins: C0101row.project_main_funding_target,
          tokens: C0101row.project_alternative_funding_target_max
        }
      }
    }
  },

  mutations: {
    SET_ROW (state, payload) {
      if (payload.project_funding_target) {
        this.commit('C0101Project/SET_ROW_MERGE', {
          project_main_funding_target: payload.project_funding_target.coins,
          project_alternative_funding_target_max: payload.project_funding_target.tokens
        })
      }

      state.row = payload
    }
  },

  actions: {
    async doEdit ({ state }, payload) {
      return await ApiUtils.postData({
        data: [{
          api: StoreConst.ACTION.doEdit.api,
          input: { ...state.row, ...payload }
        }]
      })
    }
  }
}

export default C2001Const.getStore(store)
